var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtuozzo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: -630,
    viewBox: "21.2 262.7 600 116.8",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m177.7 312h-.7l-1.3-11.2h-10.7v75.5h14v-48c3.4-9.2 10.2-14.3 19.9-15.4v-12.4c-10.1-.3-17.4 4.8-21.2 11.5",
    fill: "#231815"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58.9 300.6 15.5-28.4h-13.8v-9.5h31.2l-15.5 28.1 14.5-.1v9.9z",
    fill: "#ba2b36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m112.7 271.6-36.7 83.8-.6 2h-.6l-.7-2-36.9-83.8h-16l47.4 104.8h13l47.1-104.8zm205.8 73.9c0 20.4-10.8 34-31.6 34s-31.7-13.7-31.6-34v-45h14.4v43.6c0 15.9 7.7 22.1 17.1 22.1s16.9-6.2 17.1-22.1v-43.6h14.4v45zm-191.1-44.9h14.7v75.8h-14.7zm81.4 48c0 17.9 8.6 28.5 26.5 28.5h4v-12.4c-12.8-.2-16.3-6.2-16.3-20.7v-31.2h18.5v-12.2h-18.5v-28.9h-14.2zm263.7-48.1h-47.8v11.9h26.6l-28.5 63.9h51.9v-11.9h-31zm59.9 0h-47.8v11.9h26.5l-28.4 63.9h52v-11.9h-31zm-158.3 65.7c-14.8 0-25.6-12.5-25.6-27.7s10.8-27.7 25.6-27.7 25.6 12.5 25.6 27.7-10.8 27.7-25.6 27.7m0-68.7c-23.1 0-40.6 17.9-40.6 41s17.5 41 40.6 41 40.6-17.9 40.6-41-17.5-41-40.6-41m206.5 68.7c-14.8 0-25.6-12.5-25.6-27.7s10.8-27.7 25.6-27.7 25.6 12.5 25.6 27.7-10.8 27.7-25.6 27.7m0-68.7c-23.1 0-40.6 17.9-40.6 41s17.5 41 40.6 41 40.6-17.9 40.6-41-17.5-41-40.6-41",
    fill: "#231815"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtuozzo);
export default __webpack_public_path__ + "static/media/virtuozzo.8bf9bc32cacbb5fa63c008fa9906ce99.svg";
export { ForwardRef as ReactComponent };